import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import DialogWrapper from '../../components/dialog/Dialog';
import BaseButtonWithIcon from '../button/BaseButtonWithIcon';
import iconZoom from '../../assets/images/icon-zoom'
import {customEvent} from '../../utils/analyticsUtil';
import {getVideoMeetingUrl} from '../../utils/userUtility';
import {actions, category, DialogTypes, events} from '../../constants/enums';
import './styles.scss';

@injectIntl
@inject('dialogStore')
@observer
class TeacherStartMeetingDialog extends Component {
    renderBullets = () => {
        const numListItems = 5;

        let result = [];
        for (let i = 1; i < numListItems + 1; i++) {
            result.push(<li key={`Bullet${i}`}><FormattedMessage id={`zoom.start.dialog.list.item${i}`}/></li>);
        }
        return result;
    };

    handleClick = () => {
        customEvent(events.CustomEvent, {category: category.Zoom, action: actions.StartAMeeting, label: this.props.compact ? 'UpperBar' : 'Timeline'});
        window.open(getVideoMeetingUrl(), '_blank');
        this.props.dialogStore.closeDialog(DialogTypes.TeacherStartMeeting);
    }

    render() {
        const {onClose, open, intl: {formatMessage: translate}} = this.props;
        const dialogProps = {
            classes: {root: 'teacher-meeting-modal-root', paper: 'paper'},
            open: open,
            onExited: onClose,
            onClose: onClose
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="teacher-meeting-modal">
                    <button className="teacher-meeting-modal-close" onClick={onClose}>
                        <Close/>
                    </button>
                    <h3><FormattedMessage id={'zoom.start.dialog.title'}/></h3>
                    <ol className="teacher-meeting-info-list list-unstyled">
                        {this.renderBullets()}
                    </ol>
                    <div className="teacher-meeting-modal-buttons">
                        <BaseButtonWithIcon
                            label={translate({id: 'zoom.start.dialog.button.text'})}
                            icon={iconZoom}
                            viewBox='0 0 768 768'
                            onClick={this.handleClick}
                        />
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default TeacherStartMeetingDialog;
